import { render, staticRenderFns } from "./comp3.vue?vue&type=template&id=7c19ff5b&scoped=true"
import script from "./comp3.vue?vue&type=script&lang=ts"
export * from "./comp3.vue?vue&type=script&lang=ts"
import style0 from "./comp3.vue?vue&type=style&index=0&id=7c19ff5b&prod&lang=scss&scoped=true"
import style1 from "./comp3.vue?vue&type=style&index=1&id=7c19ff5b&prod&lang=scss&scoped=true"
import style2 from "./comp3.vue?vue&type=style&index=2&id=7c19ff5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c19ff5b",
  null
  
)

export default component.exports